import request from "axios"
import api from "./api"

export const postBlock = async (
        blockId: string,
        body: any ,
        params?: any,
    ) => {

    let block;
    let loading = true;
    let isError = false

    try {
        const { data } = await api.post( 
            blockId, {
                ...body,
                params: params
            }
        )

        block = data,
        loading = false,
        isError = false

    } catch (error) {
        let response = null

        if (request.isAxiosError(error) && error.response) {
            response = error.response?.data
        }

        block = response,
        loading = false,
        isError = true

    } finally {
        return {
            block: block,
            loading: loading,
            isError: isError
        }
    }
}